import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import {
  Box,
  CardContent,
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
} from '@mui/material';
import { PlaceHolderText } from 'components/PlaceholderCard/PlaceholderCard';
import Progress from 'components/Progress/Progress';
import useList from 'hooks/useList';
import { Card, Typography } from 'bso-ui';
import API from 'common/api';
import ModemStatus from './ModemStatus';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2)
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const ModemsList = () => {
  const classes = useStyles();
  const height = '80vh';
  const query = {
    storeKey: 'modem-list',
    apiEndpoint: API.MONITORING_CLIENTS,
  };
  const [{
    data, isLoading, isError, isFetched
  }] = useList(query.storeKey, query.apiEndpoint, null, { refetchInterval: 60000 });

  const filteredResults = [];

  if (!isLoading && data && data.length > 0) {
    const seenHostnames = new Set();

    data.forEach((item) => {
      const suffix = item.name?.slice(-3);
      if (!['LAN', 'WAN'].includes(suffix)) return;

      const hostname = item.name.slice(0, -4);
      if (seenHostnames.has(hostname)) return;

      seenHostnames.add(hostname);
      filteredResults.push({ ...item, name: hostname });
    });
  }

  if (isError || (isFetched && !data)) {
    return (
      <div style={{ height }}>
        <PlaceHolderText variant="h3" content="Error getting modems" height="100%" />
      </div>
    );
  }

  const renderData = () => (
    <Card
      id="ModemsListCard"
      className={clsx(classes.root)}
    >
      <CardContent className={classes.content}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ flex: 1 }} />
        </div>
        <div className={classes.inner}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><Typography variant="subtitle1">Hostname</Typography></TableCell>
                <TableCell><Typography variant="subtitle1">Ping wan</Typography></TableCell>
                <TableCell><Typography variant="subtitle1">Ping lan</Typography></TableCell>
              </TableRow>
            </TableHead>
            {filteredResults && filteredResults.length > 0
              ? (
                <TableBody>
                  {filteredResults.map((item) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={item.name}
                    >
                      <TableCell height={44}>
                        <Typography color="primary" variant="body2" component="span">{item.name}</Typography>
                      </TableCell>
                      <ModemStatus type="WAN" hostname={item.name} />
                      <ModemStatus type="LAN" hostname={item.name} />
                    </TableRow>
                  ))}
                </TableBody>
              )
              : null}
          </Table>
        </div>
      </CardContent>
    </Card>
  );

  return (
    <Container>
      <Box py={3}>
        <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
          <Typography id="ModemsTitle" variant="h2" color="primary">Modems_</Typography>
          <span style={{ flex: 1 }} />
        </Toolbar>
        {!isLoading
          ? renderData()
          : <Progress />}
      </Box>
    </Container>
  );
};

export default ModemsList;
